//  WARNING!:: The following is imported from Create React App.  It uses older React components,
//  which are now deprecated. When you upgrade the React version, be sure to update the current
//  version # in .eslint.cjs

import React from 'react'; 
import ReactDOM from 'react-dom';
import AppRoutes from './app/AppRoutes';
import AppStateContextProviders from './app/AppStateContextProviders';
import PageTemplate from '@usas/ui-web/components/pageTemplate/PageTemplate';
import { loadConfig } from '@usas/ui-web/config/RuntimeConfig';

const render = () => {
  ReactDOM.render(
    <React.StrictMode>
      <PageTemplate
        AppStateContextProviders={AppStateContextProviders}
        AppRoutes={AppRoutes} />
    </React.StrictMode>,
    document.getElementById('root')
  );
};

loadConfig().then(render).catch((error) => {
  console.error(error);
  document.getElementById('root').textContent = 'This page could not load its configuration. Refresh to try again.';
});

//  The following is the default setup for Vite.  It uses the latest React components,
//  Which SWIMS currently can't use.

// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import App from './app/App';

// ReactDOM.createRoot(document.getElementById('root')).render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
// );
